import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=f5fc2c34&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=f5fc2c34&scoped=true&lang=css&"
import style1 from "./Editor.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fc2c34",
  null
  
)

component.options.__file = "Editor.vue"
export default component.exports